<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
export default {
  components: {},
  name: "app",
  computed: {
    layout() {
      let route = this.$route.matched.find(
        item => item.meta.layout !== undefined
      );

      return route ? route.meta.layout : "default-layout";
    }
  }
};
</script>
